import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { DropdownItem } from 'src/shared/components/dropdown/dropdownItem';
export function DropdownItemLink({ to, target, ...rest }) {
    return (_jsx(Link, { to: to, target: target, ...(target === '_blank' && { rel: 'noreferrer noopener' }), slot: "items", style: {
            '--hc-dropdown-item-host-last-child-border-bottom': '0.0625rem solid var(--hc-color-neutral-200)'
        }, children: _jsx(DropdownItem, { slot: undefined, ...rest }) }));
}
